import { Form, Formik, FormikProps } from 'formik';
import { useHistory } from 'react-router';
import Button from '@cpg-its/ads.common.button';
import Banner from '@cpg-its/ads.containers.banner';
import { FormGroup, Hidden } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../../root/tcsm-model';
import { AnnualEnrollmentProps, NewHireProps } from '../../../arc/models/arc-epi-props';
import { CalculatedTiers } from '../../../arc/features/new-hire-enrollment/models/new-hire-enrollment-models';
import { BenefitEnrollmentStep } from '../../../arc/features/new-hire-enrollment/models/pension-enrollment-models';
import { CoverageFormModel, CoveragePerson, DisplayLabels, GetNewHireCoverageValidationSchema, NewHireCoverageState, PlanTypes, declineCoverageReasonOther, DeclinedValue } from '../../../arc/features/new-hire-enrollment/enrollment/models/coverage-models';
import { MemberCoverageFormModel } from '../../../arc/features/new-hire-enrollment/member/models/member-coverage-model';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { AccountInfoRoutes } from '../../constants/routes';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { parseLov } from '../../../../global/helpers/form-data-helper';
import { WhoWillEnrollCriterias, WhoWillEnrollOptions } from '../../../arc/features/new-hire-enrollment/models/who-will-enroll-models';
import { GetPageButtonText, GetPageHeaderContent, getRateByCodeAndTier } from '../../../arc/features/new-hire-enrollment/enrollment/helpers/coverage-display-helpers';
import { setCurrentNewHireBenefitEnrollmentStep } from '../../../arc/features/new-hire-enrollment/slice/new-hire-enrollment-slices';
import { GetAdminValidationModel, calculateTiers, getBillingAccountInitialValues } from '../../../arc/features/new-hire-enrollment/enrollment/helpers/coverage-form-helpers';
import { AETiers, SelfText } from '../../../annual-enrollment/models/annual-enrollment-models';
import { DividerSection } from '../../../../../stories/divider-section';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { PersonCoverage } from '../../../arc/features/new-hire-enrollment/enrollment/coverage/person-coverage';
import { FormField } from '../../../../global/components/form-element/form-field';
import { PlanSelectionItem } from '../../../arc/features/new-hire-enrollment/enrollment/coverage/plan-selection-item';
import { DeskTopTierLabel } from '../../../arc/features/new-hire-enrollment/enrollment/coverage/tier-labels-desktop';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { FormWrapper } from '../../../../global/components/form-wrapper';
import { TcsmModal } from '../../../../global/components/tcsm-modal';
import { ButtonWrapper } from '../../../../global/components/layout/button-wrapper';
import { onSubmitCoverage, PrepareMidYearConfirmationModel, GetMyCpgMidYearInitialValues, GetNonRemovedDependents } from './helpers/mycpg-midyear-coverage-form-helpers';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { MyCPGMidYearProps } from './models/mycpg-midyear-epi-props';
import { getFormattedDate } from '../../../../global/helpers/date-helpers';
import { CoverageReview } from '../../../arc/features/new-hire-enrollment/enrollment/coverage/coverage-review';
import { NewHireEnrollmentRoutes } from '../../../arc/features/new-hire-enrollment/models/new-hire-routes';
import { MyCpgMidYearInitialValues } from './models/mycpg-mid-year-models';
import { selectedReviewItemStyles } from '../../../../global/constants/theme/styles/components/selected-review-item';
import { getTierLabel } from '../../../annual-enrollment/helpers/annual-enrollment-helpers';
import { MyCPGCoverageCostSummary } from '../../../annual-enrollment/components/mycpg-coverage-cost-summary';

export function MyCpgMidyearCoverageForm() {
    const settings = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
    const aeSettings = useSelector<TcsmStates, AnnualEnrollmentProps>(state => state?.epiProps?.annualEnrollmentSettingsState?.epiContent);
    const newHireSettings = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
    const labelSettings = useSelector<TcsmStates, LabelSettingProps>(state => state.epiProps?.labelSettingState?.epiContent);

    const midYearSettings = useSelector<TcsmStates, MyCPGMidYearProps>(state => state?.epiProps?.myCpgMidyearSettingsState?.epiContent);
    const displayTierMedical = useSelector<TcsmStates, CalculatedTiers>(state => state?.newHireEnrollmentState?.tierToDisplayMedical);
    const displayTierDental = useSelector<TcsmStates, CalculatedTiers>(state => state?.newHireEnrollmentState?.tierToDisplayDental);
    const currentStep = useSelector<TcsmStates, BenefitEnrollmentStep>(state => state?.newHireEnrollmentState.currentEnrollmentStep);
    const memberCoveragePeople = useSelector<TcsmStates, CoveragePerson[]>(state => state?.newHireEnrollmentState?.newHireCoverageState?.eligible_dependents);
    const coverageState = useSelector<TcsmStates, NewHireCoverageState>(state => state?.newHireEnrollmentState?.newHireCoverageState);

    const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);
    const [removeSelfDialogGroup, setRemoveSelfFlag] = useState<PlanTypes>(PlanTypes.None);
    const [reselectSelf, setReselectSelfFlag] = useState<PlanTypes>(PlanTypes.None);
    const [previousUrl, setPreviousUrl] = useState<string>(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const labelSetting = useSelector<TcsmStates, LabelSettingProps>(state => state.epiProps.labelSettingState.epiContent);
    const gpsItem = useGpsType(currentStep === BenefitEnrollmentStep.COVERAGE ? GpsType.MYCPG_MIDYEAR_COVERAGE : GpsType.MYCPG_MIDYEAR_REVIEW);
    const declineReasonLov = useSelector<TcsmStates, any>(state => state.lovProcState?.mlpsLov?.medicalDeclineReason);
    const declinedCoverageReasonOptions = declineReasonLov ? parseLov(declineReasonLov) : [];
    const hasMedical = coverageState?.eligible_plans?.medical?.plans?.length > 0;
    const hasDental = coverageState?.eligible_plans?.dental?.plans?.length > 0;
    const todayDate = new Date();
    const whoWillEnroll = useSelector<TcsmStates, WhoWillEnrollCriterias>(state => state?.newHireEnrollmentState.whoWillEnrollCriteria);
    const setInitialValues: MyCpgMidYearInitialValues = GetMyCpgMidYearInitialValues(coverageState);
    const selectedItemClasses = selectedReviewItemStyles();

	const validationSchema = GetNewHireCoverageValidationSchema(
		{
			memberWillSelectMedical: null,
			memberWillSelectDental: null,
			memberWillSelectLtd: null,
			memberWillSelectStd: null,
		},
		aeSettings,
		settings,
		labelSetting,
		hasMedical,
		GetAdminValidationModel(coverageState),
	);

    const myCpgMidYearPath = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${AccountInfoRoutes.Midyear}`);

    const relationshipPath = `${myCpgMidYearPath}${AccountInfoRoutes.RelationshipsSegment}`;

    const currentEvent = useSelector<TcsmStates, string>(state => state?.newHireEnrollmentState?.myCpgOpenEnrollment[0]?.qualifying_event);
    const currentEventDate = useSelector<TcsmStates, string>(state => state?.newHireEnrollmentState?.myCpgOpenEnrollment[0]?.qualifying_event_date);

    const shouldDisableSubmit = (formProps: FormikProps<MemberCoverageFormModel>) => {

        return currentStep === BenefitEnrollmentStep.REVIEW && !formProps.values.agreement;
    };

    const handleClose = () => {
        setPreviousUrl(null);
    };

    const confirmGoback = (url: string) => {
        history.push(url);
    };

    const onCancel = () => {

        if (currentStep === BenefitEnrollmentStep.REVIEW) {

            dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.COVERAGE));
            return;
        }

        history.push(relationshipPath);

    };

    const onSuccess = (values: CoverageFormModel) => {

        const midYearConfirmationModel = PrepareMidYearConfirmationModel(
            newHireSettings,
            labelSettings,
            values,
            coverageState,
            displayTierMedical,
            displayTierDental,
            currentEvent,
            currentEventDate);

        history.push({
            pathname: `${myCpgMidYearPath}${NewHireEnrollmentRoutes.Confirmation}`,
            search: `?status=${currentEvent}`,
            state: {
                midYearConfirmationModel,
            },
        });

    };

    const ghlDefaultValues = (coverageState?.eligible_plans?.group_life?.plans || []).reduce((acc, glp) => ({ ...acc, [`volume${glp?.code}`]: '0' }), {});

    const initialValues: CoverageFormModel = {
        [PlanTypes.M]: setInitialValues?.selectedMedicalPlanCode,
        [PlanTypes.D]: setInitialValues?.selectedDentalPlanCode,
        [PlanTypes.G]: setInitialValues?.selectedGroupPlanCode,
        [PlanTypes.W]: setInitialValues?.selectedStdPlanCode,
        [PlanTypes.L]: setInitialValues?.selectedLtdPlanCode,
        [PlanTypes.U]: setInitialValues?.selectedUeiPlanCode,
        M_billingAccountType: getBillingAccountInitialValues(coverageState?.eligible_plans?.medical?.billing_preference),
        D_billingAccountType: getBillingAccountInitialValues(coverageState?.eligible_plans?.dental?.billing_preference),
        G_billingAccountType: getBillingAccountInitialValues(coverageState?.eligible_plans?.group_life?.billing_preference),
        W_billingAccountType: getBillingAccountInitialValues(coverageState?.eligible_plans?.short_term_disability?.billing_preference),
        L_billingAccountType: getBillingAccountInitialValues(coverageState?.eligible_plans?.long_term_disability?.billing_preference),
        U_billingAccountType: getBillingAccountInitialValues(coverageState?.eligible_plans?.uei?.billing_preference),
        medicalDependents: setInitialValues?.medicalDependents,
        dentalDependents: setInitialValues?.dentalDependents,
        M_member: whoWillEnroll?.medical === WhoWillEnrollOptions.member,
        D_member: whoWillEnroll?.dental === WhoWillEnrollOptions.member,

        W_member: whoWillEnroll?.std === WhoWillEnrollOptions.member,
        L_member: whoWillEnroll?.ltd === WhoWillEnrollOptions.member,

        medicalDeclineReason: setInitialValues?.medicalDeclineReason,
        medicalDeclineReasonOther: setInitialValues?.medicalDeclineReasonOther,
        dentalDeclineReason: setInitialValues?.dentalDeclineReason,
        dentalDeclineReasonOther: setInitialValues?.dentalDeclineReasonOther,

        memo: '',
        specialRequests: setInitialValues?.specialRequests,
        agreement: false,
        cafeteriaAcknowledgement: false,
        ...ghlDefaultValues,
    };

    const buttonText = GetPageButtonText(currentStep, settings);
    const pageHeader = GetPageHeaderContent(currentStep, settings, null);
    const ineligibleDepedentGuids = coverageState?.eligible_dependents?.filter(dep => dep.remove).map(dep => dep.guid);


    useEffect(() => {
        dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.COVERAGE));

        if (coverageState?.eligible_plans?.medical) {
            calculateTiers(
                coverageState?.eligible_plans?.medical,
                [SelfText].concat(GetNonRemovedDependents(ineligibleDepedentGuids, coverageState?.eligible_plans?.medical?.current?.dependents)),
                dispatch,
                memberCoveragePeople,
                PlanTypes.M,
            );
        }
        if (coverageState?.eligible_plans?.dental) {
            calculateTiers(
                coverageState?.eligible_plans?.dental,
                [SelfText].concat(GetNonRemovedDependents(ineligibleDepedentGuids, coverageState?.eligible_plans?.dental?.current?.dependents)),
                dispatch,
                memberCoveragePeople,
                PlanTypes.D,
            );
        }
    }, [coverageState]);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [currentStep]);
    function RenderCoveragePerson(formProps: FormikProps<MemberCoverageFormModel>) {
        if (currentStep === BenefitEnrollmentStep.REVIEW) {
            return null;
        }

        if (!hasMedical && !hasDental) {
            return null;
        }

        return (
            <div className='grid-main-content'>
                <DividerSection removeDivider >
                    <ContentSpacer>
                        <WysiwygWithReactLink content={settings?.participantSelectionDescription} />
                    </ContentSpacer>
                    <FormGroup>
                        {
                            hasMedical &&
                            <ContentSpacer>
                                <PersonCoverage
                                    planType={PlanTypes.M}
                                    fieldName='medicalDependents'
                                    groupLabel={settings?.medicalCoverageText}
                                    settings={settings}
                                    formProps={formProps}
                                    eligibleDependents={memberCoveragePeople}
                                    plan={coverageState?.eligible_plans?.medical}
                                    setRemoveSelfFlag={setRemoveSelfFlag}
                                    setReselectSelfFlag={setReselectSelfFlag}
                                    removeSelfDialogGroup={removeSelfDialogGroup}
                                    reselectSelf={reselectSelf}
                                    displayPlanSelectionDioApprover
                                />
                            </ContentSpacer>
                        }
                        {
                            hasDental &&
                            <PersonCoverage
                                planType={PlanTypes.D}
                                fieldName='dentalDependents'
                                groupLabel={settings?.dentalCoverageText}
                                settings={settings}
                                formProps={formProps}
                                eligibleDependents={memberCoveragePeople}
                                plan={coverageState?.eligible_plans?.dental}
                                setRemoveSelfFlag={setRemoveSelfFlag}
                                setReselectSelfFlag={setReselectSelfFlag}
                                removeSelfDialogGroup={removeSelfDialogGroup}
                                reselectSelf={reselectSelf}
                                displayPlanSelectionDioApprover
                            />
                        }
                    </FormGroup>
                </DividerSection>
            </div>
        );
    }

    function RenderNoCoverageReasonOther(formProps: FormikProps<any>, fieldName: string, otherFieldName: string) {
        if (formProps?.values[fieldName] !== declineCoverageReasonOther) return null;

        return (
            <>
                <p className='custom-sublabel'>{settings?.declineCoverageReasonSelectMessage}</p>
                <FormField
                    name={otherFieldName}
                    label={aeSettings.declineMedicalCoverageReasonOtherLabel}
                    component='input'
                    multiline
                    rows={5}
                    touched={formProps.touched}
                    errors={formProps.errors}
                    required
                />
            </>
        );
    }

    function RenderNoCoverageReason(
        formProps: FormikProps<any>,
        selectedMedicalPlan: string,
        fieldName: string,
        otherFieldName: string,
        memberEnroll: boolean,
    ) {
        if ((selectedMedicalPlan !== DeclinedValue) || memberEnroll) return null;

        return (
            <div className='grid-nested'>
                <div className='grid-main-content'>

                    <DividerSection greySection>
                        <ContentSpacer>
                            <h2>{settings.declineCoverageReasonGroupTitle}<span className='red-text'>*</span></h2>
                        </ContentSpacer>
                        <FormGroup>
                            <div className='form-item'>
                                <FormField
                                    name={fieldName}
                                    label={settings.declineCoverageReasonSelectLabel}
                                    component='input'
                                    options={declinedCoverageReasonOptions}
                                    errors={formProps.errors}
                                    touched={formProps.touched}
                                    select
                                    required
                                    placeholder={settings.declineCoverageReasonSelectPlaceHolder}
                                />

                            </div>
                            {RenderNoCoverageReasonOther(formProps, fieldName, otherFieldName)}
                        </FormGroup>
                    </DividerSection>
                </div>
            </div>
        );
    }

    function RenderPlans(formProps: FormikProps<MemberCoverageFormModel>) {
        const medicalAmount: number = getRateByCodeAndTier(coverageState?.eligible_plans?.medical?.plans, formProps?.values?.M, displayTierMedical?.selected_tier);
        const dentalAmount: number = getRateByCodeAndTier(coverageState?.eligible_plans?.dental?.plans, formProps?.values?.D, displayTierDental?.selected_tier);
        const medicalAvailable: boolean = coverageState?.eligible_plans?.medical?.plans?.length > 0;
        const dentalAvailable: boolean = coverageState?.eligible_plans?.dental?.plans?.length > 0;

        if (currentStep === BenefitEnrollmentStep.REVIEW) {
            return <CoverageReview
                settings={settings}
                labelSettings={labelSetting}
                formProps={formProps}
                setEditUrl={setPreviousUrl}
                basePath={myCpgMidYearPath}
                isParticipant

            />;
        }

        return (
            <>

                {
                    coverageState?.eligible_plans?.medical &&
                    <>
                        <PlanSelectionItem
                            memberEnroll={false}
                            formikProps={formProps}
                            componentModel={
                                {
                                    formPlanTypeName: PlanTypes.M,
                                    planTypeName: settings?.medicalPlanTitle,
                                    planNamesLabel: settings?.medicalPlansLabel,
                                    settings,
                                    labelSettings: labelSetting,
                                    declineOptionText: settings?.declineMedicalPlanOptionText,
                                }
                            }
                            plans={coverageState?.eligible_plans?.medical}
                            radioTableLabels={<DeskTopTierLabel settings={settings} tiers={coverageState?.eligible_plans?.medical?.plans[0]?.rates_by_tier} />}
                            setRemoveSelfFlag={setRemoveSelfFlag}
                            tierKey='tierToDisplayMedical'
                            noPlanOfferMessage={settings?.noPlanOfferMessage}
                            memberSelection
                            displayLabels={DisplayLabels.MEDICALDENTAL}
                            eligibleDependents={memberCoveragePeople}
                            displayPlanSelectionDioApprover
                        />
                        {
                            RenderNoCoverageReason(
                                formProps,
                                formProps?.values?.M,
                                'medicalDeclineReason',
                                'medicalDeclineReasonOther',
                                false,
                            )
                        }
                    </>
                }

                {
                    coverageState?.eligible_plans?.dental &&
                    <>
                        <PlanSelectionItem
                            memberEnroll={false}
                            formikProps={formProps}
                            componentModel={
                                {
                                    formPlanTypeName: PlanTypes.D,
                                    planTypeName: settings?.dentalPlanTitle,
                                    planNamesLabel: settings?.dentalPlansLabel,
                                    settings,
                                    labelSettings: labelSetting,
                                    declineOptionText: settings?.declineDentalPlanOptionText,
                                }
                            }
                            plans={coverageState?.eligible_plans?.dental}
                            radioTableLabels={<DeskTopTierLabel settings={settings} tiers={coverageState?.eligible_plans?.dental?.plans[0]?.rates_by_tier} />}
                            setRemoveSelfFlag={setRemoveSelfFlag}
                            tierKey='tierToDisplayDental'
                            noPlanOfferMessage={settings?.noPlanOfferMessage}
                            memberSelection
                            displayLabels={DisplayLabels.MEDICALDENTAL}
                            eligibleDependents={memberCoveragePeople}
                            displayPlanSelectionDioApprover
                        />
                    </>
                }

				<div className='grid-main-content'>
					<MyCPGCoverageCostSummary
						medicalAvailable={medicalAvailable}
						medicalAmount={medicalAmount}
						medicalDeclined={medicalAvailable && medicalAmount === 0}
						dentalAvailable={dentalAvailable}
						dentalAmount={dentalAmount}
						dentalDeclined={dentalAvailable && dentalAmount === 0}
						coverageSummaryTitle={aeSettings?.coverageSummaryTitle}
						medicalLabel={aeSettings?.coverageSummaryMedicalLabel}
						dentalLabel={aeSettings?.coverageSummaryDentalLabel}
						costSummaryTotalLabel={aeSettings?.coverageSummaryTotalLabel}
						monthlyCostLabel={aeSettings?.coverageSummaryMonthlyCostLabel}
						monthlyCostDescription={aeSettings?.coverageSummaryMonthlyCostDescription}
						monthlyCostTooltip={aeSettings?.coverageSummaryMonthlyCostTooltip}
					/>
				</div>

            </>
        );
    }

    function RenderFormContent(formProps: FormikProps<MemberCoverageFormModel>) {

        return (
            <>

                {
                    RenderPlans(formProps)
                }
            </>
        );

    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => onSubmitCoverage(
                dispatch,
                currentStep,
                () => onSuccess(values),
                values,
                guid,
                coverageState?.employer_id,
                coverageState?.ghl_form_id,
                displayTierMedical,
                displayTierDental,
                coverageState,
            )}
            enableReinitialize
            validationSchema={validationSchema}
        >
            {(formProps: FormikProps<CoverageFormModel>) =>
                <Form className='grid-fw-content grid-nested'>
                    <div className='grid-main-content'>
                        {
                            currentStep === BenefitEnrollmentStep.COVERAGE &&
                            <ContentSpacer>
                                <Banner
                                    banner={{
                                        type: 'warning',
                                        label: <WysiwygWithReactLink content={midYearSettings?.coverageWarningTitle?.replace('{date}', getFormattedDate(todayDate?.toString()))} />,
                                        description: <WysiwygWithReactLink content={midYearSettings?.coverageWarningDescription} />,
                                    }} />
                            </ContentSpacer>
                        }
                        <PageHeader
                            headerText={pageHeader?.title}
                            description={pageHeader?.description}
                        />
                        <Hidden mdUp>
                            <SideBarContent>
                                <GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
                            </SideBarContent>
                        </Hidden>

                        <DividerSection sectionText={aeSettings.currentPlanLabel}>
                            {
                                !initialValues[PlanTypes.M] && !initialValues[PlanTypes.D] &&
                                <WysiwygWithReactLink content={midYearSettings?.noCurrentPlanMessage} />
                            }
                            {
                                initialValues[PlanTypes.M] &&
                                <div className={`divider-section-item ${selectedItemClasses.selectedReviewItem}`}>
                                    <p><strong>{aeSettings.medicalPlanLabel}</strong></p>
                                    <div className='selected-review-item-inner mobile-stack'>

                                        <div className='selected-review-item-content'>
                                            <div>

                                                <p>{setInitialValues?.selectedMedicalPlanName}</p>
                                                <p className='input-caption'>{getTierLabel(setInitialValues?.selectedMedicalTier as AETiers, aeSettings)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                initialValues[PlanTypes.D] &&
                                <div className={`divider-section-item ${selectedItemClasses.selectedReviewItem}`}>
                                    <h6>{aeSettings.dentalPlanLabel}</h6>
                                    <div className='selected-review-item-inner mobile-stack'>

                                        <div className='selected-review-item-content'>
                                            <div>
                                                <p>{setInitialValues?.selectedDentalPlanName}</p>
                                                <p className='input-caption'>{getTierLabel(setInitialValues?.selectedDentalTier as AETiers, aeSettings)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </DividerSection>
                        {
                            RenderCoveragePerson(formProps)
                        }
                    </div>
                    <Hidden smDown>
                        <div className='grid-sidebar'>
                            <SideBarContent>
                                <GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
                            </SideBarContent>
                        </div>
                    </Hidden>
                    <FormWrapper
                        formikProps={formProps}
                        submitText={buttonText?.continue}
                        cancelText={buttonText?.prev}
                        onCancel={onCancel}
                        preventButtonDisableValidation
                        helperText={currentStep === BenefitEnrollmentStep.COVERAGE && settings?.memberCoverageContinueDescription}
                        submitDisabled={shouldDisableSubmit(formProps)}
                    >
                        {
                            RenderFormContent(formProps)
                        }
                    </FormWrapper>
                    <TcsmModal
                        open={previousUrl != null}
                        handleClose={handleClose}>
                        <>
                            <h2>{aeSettings.previousStepModalTitle}</h2>
                            <div dangerouslySetInnerHTML={{ __html: aeSettings?.previousStepModalDescription }} />
                            <ButtonWrapper flexEnd>
                                <Button type='button' buttonStyle='tertiary' text={aeSettings?.previousStepModalCancel} backgroundColor='#808080' onClick={handleClose} />
                                <Button type='button' buttonStyle='primary' text={aeSettings?.previousStepModalConfirm} backgroundColor='#0000FF' onClick={() => confirmGoback(previousUrl)} />
                            </ButtonWrapper>
                        </>

                    </TcsmModal>
                </Form>}
        </Formik >
    );
}

